{
  "name": "efaact-central",
  "version": "19.6.7",
  "scripts": {
    "start": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve --host 0.0.0.0 --disable-host-check",
    "start-local": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve --configuration local --host 0.0.0.0 --disable-host-check",
    "start-qbo": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve --configuration QBOsandbox --host 0.0.0.0 --disable-host-check",
    "start-prod": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve --host 0.0.0.0 --configuration production=true --disable-host-check",
    "build": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng build",
    "test": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng test --ts-config ./src/tsconfig.spec.json",
    "test-chromium": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng test --ts-config ./src/tsconfig.spec.json --browsers=ChromiumHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "preversion": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng test --watch=false --ts-config ./src/tsconfig.spec.json --code-coverage --browsers=ChromeHeadless",
    "postversion": "git commit -a -m \"update version\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.5",
    "@angular/cdk": "^19.2.8",
    "@angular/common": "^19.2.5",
    "@angular/compiler": "^19.2.5",
    "@angular/core": "^19.2.5",
    "@angular/forms": "^19.2.5",
    "@angular/localize": "^19.2.5",
    "@angular/material": "^19.2.8",
    "@angular/platform-browser": "^19.2.5",
    "@angular/platform-browser-dynamic": "^19.2.5",
    "@angular/router": "^19.2.5",
    "@fullcalendar/core": "^4.4.0",
    "@fullcalendar/daygrid": "^4.4.0",
    "@fullcalendar/interaction": "^4.4.0",
    "@fullcalendar/timegrid": "^4.4.0",
    "@ngrx/data": "^19.1.0",
    "@ngrx/effects": "^19.1.0",
    "@ngrx/entity": "^19.1.0",
    "@ngrx/store": "^19.1.0",
    "@ngrx/store-devtools": "^19.1.0",
    "@ngtools/webpack": "^19.2.6",
    "@primeng/themes": "^18.0.2",
    "@primeuix/utils": "^0.5.3",
    "@shopify/buy-button-js": "^2.2.1",
    "@shopify/shopify-api": "^5.2.0",
    "@tailwindcss/postcss": "^4.1.3",
    "@types/modernizr": "^3.5.3",
    "@uirouter/angular": "^16.1.0",
    "@uirouter/core": "^6.0.8",
    "@uirouter/rx": "^1.0.0",
    "@uirouter/visualizer": "^7.2.1",
    "backoff-rxjs": "^6.5.3",
    "bufferutil": "^4.0.1",
    "chart.js": "^3.3.2",
    "chartjs-plugin-zoom": "^1.2.1",
    "core-js": "^3.32.0",
    "file-saver": "^2.0.5",
    "html-webpack-plugin": "^4.5.0",
    "iconv-lite": "^0.6.3",
    "immutable": "^3.8.2",
    "jquery": "^3.5.1",
    "jqueryui": "^1.11.1",
    "json-diff": "^0.5.4",
    "just-clone": "^6.0.1",
    "just-compare": "^2.1.1",
    "lodash": "^4.17.19",
    "lodash.flattendeep": "^4.4.0",
    "modernizr": "^3.11.3",
    "moment": "^2.24.0",
    "moment-timezone": "^0.5.28",
    "ng-mocks": "^14.13.4",
    "ng-packagr": "^19.2.1",
    "ngrx-store-freeze": "^0.2.4",
    "ngrx-store-localstorage": "^19.0.0",
    "postcss": "^8.5.3",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.10",
    "quill": "^2.0.3",
    "rxjs": "^6.6.7",
    "sass": "^1.53.0",
    "tabulator-tables": "^4.9.3",
    "tailwindcss": "^4.1.3",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.0.0",
    "utf-8-validate": "^5.0.2",
    "webpack": "^5.30.0",
    "xlsx": "^0.16.9",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1902.6",
    "@angular-devkit/build-angular": "^19.2.6",
    "@angular-devkit/schematics": "^19.2.6",
    "@angular-eslint/builder": "^19.2.0",
    "@angular-eslint/eslint-plugin": "^19.2.0",
    "@angular-eslint/eslint-plugin-template": "^19.2.0",
    "@angular-eslint/template-parser": "^19.2.0",
    "@angular/cli": "^19.2.6",
    "@angular/compiler-cli": "^19.2.5",
    "@angular/language-service": "^19.2.5",
    "@babel/compat-data": "~7.8.0",
    "@ngrx/schematics": "^19.1.0",
    "@schematics/angular": "^19.2.6",
    "@types/jasmine": "~5.1.0",
    "@types/jasminewd2": "~2.0.8",
    "@types/jquery": "^3.3.31",
    "@types/node": "^22.0.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "codelyzer": "^6.0.2",
    "eslint": "^9.0.0",
    "eslint-config-angular": "^0.5.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-angular": "^4.1.0",
    "eslint-plugin-prettier": "^5.0.0",
    "jasmine-core": "^5.0.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-clear-screen-reporter": "^1.0.0",
    "karma-coverage": "^2.0.3",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "karma-jasmine-order-reporter": "^1.1.0",
    "karma-mocha-reporter": "^2.2.5",
    "prettier": "^3.0.0",
    "protractor": "~7.0.0",
    "puppeteer": "^23.0.0",
    "ts-node": "~10.9.0",
    "tslint": "~6.1.0",
    "typescript": "~5.8.0"
  },
  "schematics": "./src/schematics/ef-schematics/src/collection.json"
}
